import styled from "styled-components";
import { ellipsis } from "../../../mixins/ellipsis";
import isPropValid from "@emotion/is-prop-valid";
export const ContentContainer = styled.span.withConfig({
    shouldForwardProp: isPropValid,
}) `
  &,
  & * {
    ${ellipsis}
  }
`;
export default ContentContainer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0VsbGlwc2lzL3N0eWxlZC9Db250ZW50Q29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUNwRCxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUVqRCxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUNyRCxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7O01BR0ksUUFBUTs7Q0FFYixDQUFDO0FBRUYsZUFBZSxnQkFBZ0IsQ0FBQyJ9